import { OperationType } from '../RouteAdmin';

export const SUBTITLE_COLOR = '#696F88';
export const COUNT_COLOR = '#0071CD';
export const REMAINING_COLOR = '#DFE2E7';
export const SELECTION_COLOR = '#0092E4';

export const START_DATE_TIME_LABEL = 'Start Date & Time';
export const NO_DATE_AVAILABLE = 'No date available';
export const NO_FIELDS_MESSAGE = 'No fields';
export const FIELDS_LABEL = 'Fields';
export const INTEGRATION_TOOLTIP = 'Integration';
export const LOADING_RECORDS_MESSAGE = 'Loading records...';
export const CREATE_NEW_APPLICATION = 'Create New';
export const FILTER_LABEL = 'Filter';
export const ADJUST_FILTERS_LABEL = 'Adjust Filters';
export const CLEAR_FILTERS_LABEL = 'Clear Filters';

export const BUTTON_SIZE = 'middle' as const;
export const ICON_CLASS = 'w-4 h-4';

export const ROW_SELECTION_TYPE = 'radio' as const;
export const TABLE_SIZE = 'default' as const;

export const TABLE_CONTAINER_HEIGHT_VAR = '--table-container-height';
export const RESIZE_EVENT = 'resize';

// Layout Constants
export const PAGINATION_HEIGHT = 60;
export const SCROLL_OFFSET_HEIGHT = 290;

// No Filter and Search results

export const EMPTY_STATE_CONTENT = {
  [OperationType.APPLICATION]: {
    search: {
      title: 'No Applications Found',
      content: 'Change the selected season or try a different search.'
    },
    filter: {
      title: 'No Applications Found',
      content: 'Clear or adjust filter selections to see Applications.'
    }
  },
  [OperationType.WORK_ORDER]: {
    search: {
      title: 'No Work Orders Found',
      content: 'Change the selected season or try a different search.'
    },
    filter: {
      title: 'No Work Orders Found',
      content: 'Clear or adjust filter selections to see Work Orders.'
    }
  }
};
